import { render } from "./ConfigUpdate.vue?vue&type=template&id=427f7d40&scoped=true"
import script from "./ConfigUpdate.vue?vue&type=script&lang=js"
export * from "./ConfigUpdate.vue?vue&type=script&lang=js"

import "./ConfigUpdate.vue?vue&type=style&index=0&id=427f7d40&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-427f7d40"]])

export default __exports__